export default function toggleInArray(a, v) {
  const i = a.indexOf(v);
  const a2 = a.slice();
  if (i === -1) a2.push(v);
  else a2.splice(i, 1);
  return a2;
}
